import apiService from "../apiService"
const adminApiService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchDepartmentsAdmin: builder.query({
      query: () => ({ url: "departments" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    hardSyncDepartments: builder.mutation({
      query: (practices) => ({
        url: "departments/hardsync",
        method: "POST",
        body: { practices },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    updateDepartment: builder.mutation({
      query: (department) => ({
        url: "departments",
        method: "PUT",
        body: { department },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    subscribeSlug: builder.mutation({
      query: ({ id, data }) => ({
        url: `departments/${id}/subscribeslug`,
        method: "POST",
        body: data,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    deleteSlug: builder.mutation({
      query: ({ id, source }) => ({
        url: `departments/${id}/${source}`,
        method: "DELETE",
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    patchDepartment: builder.mutation({
      query: ({ id, patch }) => ({
        url: `departments/${id}`,
        method: "PATCH",
        body: patch,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default adminApiService

export const {
  useLazyFetchDepartmentsAdminQuery,
  useUpdateDepartmentMutation,
  usePatchDepartmentMutation,
  useSubscribeSlugMutation,
  useDeleteSlugMutation,
  useLazyGetUserDetailsQuery,
  useHardSyncDepartmentsMutation,
} = adminApiService
